import { generateStripeState } from '../helper'

const options = {
  api: {
    list: () => `/api/stripe/coupons`,
    delete: ({ id }) => `/api/stripe/coupon/${id}`,
    update: ({ id }) => `/api/stripe/coupon/${id}`,
    create: () => `/api/stripe/coupon`,
    get: ({ id }) => `/api/stripe/coupon/${id}`,
  },
  state: {
    collectionName: 'coupons'
  },
  getters: {
    getPagination: 'getCouponPagination',
    getCollection: 'getCoupons'
  },
  actions: {
    list: 'listCoupons',
    delete: 'deleteCoupon',
    update: 'updateCoupon',
    create: 'createCoupon',
    get: 'getCoupon'
  },
  mutationKey: 'COUPON',
}

const {
  state: stripeState,
  getters: stripeGetters,
  actions: stripeActions,
  mutations: stripeMutations
} = generateStripeState(options)


export default {
  state: {
    ...stripeState
  },
  getters: {
    ...stripeGetters
  },
  actions:{
    ...stripeActions,
    openAddCouponDialog(stateObject) {
      this.$router.push('create-coupon')
    },
  },
  mutations:{
    ...stripeMutations
  }
}
